export function getMsAndTs(expressionid: string) {
  var query = [
  "SELECT ?cm ?m ?mt ?cmt ",
  "WHERE",
  "{",
    "<" + expressionid + "> <http://scta.info/property/hasCanonicalManifestation> ?cm .",
    "?cm <http://scta.info/property/hasTranscription> ?cmt .",
    "<" + expressionid + "> <http://scta.info/property/hasManifestation> ?m .",
    "?m <http://scta.info/property/hasTranscription> ?mt .",
  "}"].join(' ');
  return query
}